App.controller('HealthInsuranceInfoVisitCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceInfo_visit';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Umawianie wizyt';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);
}]);
